import Button from '@anm/components/buttons/Button/Button';
import { flexCenter, media } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

import TitleBlock from '../TitleBlock';
import DeleteAccountButton, { DeleteAccountButtonProps } from '../buttons/DeleteAccountButton';

export type DeleteAccountBlockProps = {};

const textAdaptive = media.tablet`
    margin: 0 0 30px 0;
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0.01em;
  margin: 0 52px 0 0;
  ${textAdaptive};
`;

const deleteAccountContentAdaptive = media.tablet`
    flex-direction: column;
    align-items: stretch;
    ${Button} {
      width: 100%;
    }
`;

const DeleteAccountContent = styled.div`
  ${flexCenter};
  justify-content: space-between;
  ${deleteAccountContentAdaptive};
`;

const DeleteAccountSection = styled.div`
  margin-bottom: 60px;
`;

const DeleteAccountBlock: FC<DeleteAccountButtonProps & DeleteAccountBlockProps> = ({ onDelete }) => (
  <DeleteAccountSection>
    <TitleBlock level={3} title="Delete Account" size="medium" />
    <DeleteAccountContent>
      <Text>
        This will instantly delete your account, including all your projects.
        <br />
        This cannot be undone.
      </Text>
      <DeleteAccountButton onDelete={onDelete} />
    </DeleteAccountContent>
  </DeleteAccountSection>
);

export default DeleteAccountBlock;
